//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





import UMUM       from  '../../library/umum.js'
import WILAYAH    from  '../../library/getWilayah'
import uniqid     from  'uniqid';
import FETCHING from  '../../library/fetching'

var UNIK = uniqid


export default {
    data () {
        return {
          FETCHING: FETCHING, 
          token : localStorage.token,
          terbitkanSurat  :false,
          modal_y:false,
          modal_n:false,

          lihat_blue:false,
          lihat_red:false,  
          lihat_pdf:false,  
            option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],

            form: {

              modul:'lapor_mati',
              id                        : UNIK,

              // m_provinsi                : '',
              // m_kabupaten               : '',
              // m_kecamatan               : '',
              // m_desa_kelurahan          : '', 

              // nama                      : 'Fajar',
              // nik                       : '125',
              // umur                      : '25',
              // pekerjaan                 : 'Pekerja',
              // alamat                    : 'Lingkar jati',
              // hubungan_dengan_yang_mati : 'DD',

              // nama_mati                 : 'Hati', 
              // nik_mati                  : '8', 
              // jk_mati                   : 'Perempuan', 
              // tgl_lahir_mati            : '2008-12-11', 
              // umur_mati                 : '25', 
              // agama_mati                : 'Islam', 

              // alamat_mati               : 'Jl Hati', 

              // provinsi_mati             : '', 
              // kabupaten_mati            : '', 
              // kecamatan_mati            : '', 
              // desa_kelurahan_mati       : '', 

              // hari_meninggal            : 'Senin', 
              // tanggal_meninggal         : '2020-12-11', 
              // waktu_meninggal           : '05:00', 
              // tempat_meninggal          : 'Dihati', 
              // penyebab_meninggal        : 'Tidak tumbuhnya cinta', 

              file_terbitan   : null,
              emailPemohon    : '',
              email_file      : null,
              email_fileOld   : '',
              email_from      : '',
              email_to        : '',
              email_subject   : '',
              email_html      : '',
              
              m_provinsi                : '74',
              m_kabupaten               : '7405',
              m_kecamatan               : '',
              m_desa_kelurahan          : '', 

              nama                      : '',
              nik                       : '',
              umur                      : '',
              pekerjaan                 : '',
              alamat                    : '',
              hubungan_dengan_yang_mati : '',

              nama_mati                 : '', 
              nik_mati                  : '', 
              jk_mati                   : '', 
              tgl_lahir_mati            : '', 
              umur_mati                 : '', 
              agama_mati                : '', 

              alamat_mati               : '', 

              provinsi_mati             : '', 
              kabupaten_mati            : '', 
              kecamatan_mati            : '', 
              desa_kelurahan_mati       : '', 


              hari_meninggal            : '', 
              tanggal_meninggal         : '', 
              waktu_meninggal           : '', 
              tempat_meninggal          : '', 
              penyebab_meninggal        : '', 

              file                      :null,

              bukti_kematian            : null,  
              bukti_kematian_old        : null,  

              status                    : 0,
              keterangan                : 0,

              keterangan_deskel         :'',
              keterangan_kecamatan      :'',
              keterangan_kabupaten      :'',

              status_deskel             :0,
              status_kecamatan          :0,
              status_kabupaten          :0,

              createdBy                 :'',
              createdAt                 :'',
              createdAt_deskel          :'',
              createdAt_kecamatan       :'',
              createdAt_kabupaten       :'',
              
            },

            wilayah : {
              uraian_provinsi           : '',
              kd_provinsi               : '',
              uraian_kabupaten          : '',
              kd_kabupaten              : '',
              uraian_kecamatan          : '',
              kd_kecamatan              : '',
              uraian_desa_kelurahan     : '',
              kd_desa_kelurahan         : '',
            },

            wilayahMati : {
              uraian_provinsi           : '',
              kd_provinsi               : '',
              uraian_kabupaten          : '',
              kd_kabupaten              : '',
              uraian_kecamatan          : '',
              kd_kecamatan              : '',
              uraian_desa_kelurahan     : '',
              kd_desa_kelurahan         : '',
            },

            list_data : [],
            list_data_kecamatan : [],
            list_data_kabupaten : [],

            page_limit : 5,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,

            UMUM : UMUM,        
            WILAYAH : WILAYAH, 

 

        }
    },
    methods: {
      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                createdBy : this.$store.state.lcProfile.id
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;  
                // console.log(res_data.data);
        });
      },

      add_data : function (){ 
        this.$store.state.modal_loading = true;

        console.log(this.form);

          // var formData = new FormData();
          // formData.append(JSON.stringify(this.form));

        var formData = new FormData(); 
        //   formData.append("modul", this.form.modul);  

          formData.append("id", uniqid());   
          formData.append("m_provinsi",                 this.form.m_provinsi)
          formData.append("m_kabupaten",                this.form.m_kabupaten)
          formData.append("m_kecamatan",                this.form.m_kecamatan)
          formData.append("m_desa_kelurahan",           this.form.m_desa_kelurahan)
          formData.append("nama",                       this.form.nama)
          formData.append("nik",                        this.form.nik)
          formData.append("umur",                       this.form.umur)
          formData.append("pekerjaan",                  this.form.pekerjaan)
          formData.append("alamat",                     this.form.alamat)
          formData.append("hubungan_dengan_yang_mati",  this.form.hubungan_dengan_yang_mati)
          formData.append("nama_mati",                  this.form.nama_mati)
          formData.append("nik_mati",                   this.form.nik_mati)
          formData.append("jk_mati",                    this.form.jk_mati)
          formData.append("tgl_lahir_mati",             this.form.tgl_lahir_mati)
          formData.append("umur_mati",                  this.form.umur_mati)
          formData.append("agama_mati",                 this.form.agama_mati)
          formData.append("alamat_mati",                this.form.alamat_mati)
          formData.append("provinsi_mati",              this.form.provinsi_mati)
          formData.append("kabupaten_mati",             this.form.kabupaten_mati)
          formData.append("kecamatan_mati",             this.form.kecamatan_mati)
          formData.append("desa_kelurahan_mati",        this.form.desa_kelurahan_mati)
          formData.append("hari_meninggal",             this.form.hari_meninggal)
          formData.append("tanggal_meninggal",          this.form.tanggal_meninggal)
          formData.append("waktu_meninggal",            this.form.waktu_meninggal)
          formData.append("tempat_meninggal",           this.form.tempat_meninggal)
          formData.append("penyebab_meninggal",         this.form.penyebab_meninggal) 
          formData.append("bukti_kematian",             this.form.bukti_kematian)
          formData.append("bukti_kematian_old",         this.form.bukti_kematian_old)
          formData.append("status",                     this.form.status)
          formData.append("keterangan",                 this.form.keterangan)
          formData.append("keterangan_deskel",          this.form.keterangan_deskel)
          formData.append("keterangan_kecamatan",       this.form.keterangan_kecamatan)
          formData.append("keterangan_kabupaten",       this.form.keterangan_kabupaten)
          formData.append("status_deskel",              this.form.status_deskel)
          formData.append("status_kecamatan",           this.form.status_kecamatan)
          formData.append("status_kabupaten",           this.form.status_kabupaten)
          formData.append("createdAt_deskel",           this.form.createdAt_deskel)
          formData.append("createdAt_kecamatan",        this.form.createdAt_kecamatan)
          formData.append("createdAt_kabupaten",        this.form.createdAt_kabupaten)
        formData.append("createdAt",                     UMUM.NOW());
          formData.append("emailPemohon",               this.form.emailPemohon);


        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "addData", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            }, 
            body: formData
        }).then(res_data => { 
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil')
            this.getView();
            // console.log(res_data);
        });
        
      },
      removeData : function(E){
        this.$store.state.modal_loading = true;

        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                bukti_kematian : this.form.bukti_kematian,
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        }); 
      },
      selectData : function(data){  
        // var a = data.m_provinsi_ibux.uraian
        console.log(data);

          this.form.id = data.pelaporan_MATI.id;

          this.form.modul                         = data.pelaporan_MATI.modul;
          this.form.m_provinsi                    = data.pelaporan_MATI.m_provinsi;
          this.form.m_kabupaten                   = data.pelaporan_MATI.m_kabupaten;
          this.form.m_kecamatan                   = data.pelaporan_MATI.m_kecamatan;
          this.form.m_desa_kelurahan              = data.pelaporan_MATI.m_desa_kelurahan;

          this.form.nama                = data.pelaporan_MATI.nama
          this.form.nik                 = data.pelaporan_MATI.nik
          this.form.umur                = data.pelaporan_MATI.umur
          this.form.pekerjaan           = data.pelaporan_MATI.pekerjaan
          this.form.alamat              = data.pelaporan_MATI.alamat
          this.form.hubungan_dengan_yang_mati = data.pelaporan_MATI.hubungan_dengan_yang_mati
          this.form.nama_mati           = data.pelaporan_MATI.nama_mati
          this.form.nik_mati            = data.pelaporan_MATI.nik_mati
          this.form.jk_mati             = data.pelaporan_MATI.jk_mati
          this.form.tgl_lahir_mati      = data.pelaporan_MATI.tgl_lahir_mati
          this.form.umur_mati           = data.pelaporan_MATI.umur_mati
          this.form.agama_mati          = data.pelaporan_MATI.agama_mati

          this.form.provinsi_mati         = data.pelaporan_MATI.provinsi_mati
          this.form.kabupaten_mati        = data.pelaporan_MATI.kabupaten_mati
          this.form.kecamatan_mati        = data.pelaporan_MATI.kecamatan_mati
          this.form.desa_kelurahan_mati   = data.pelaporan_MATI.desa_kelurahan_mati

          this.form.alamat_mati           = data.pelaporan_MATI.alamat_mati
          this.form.hari_meninggal        = data.pelaporan_MATI.hari_meninggal
          this.form.tanggal_meninggal     = data.pelaporan_MATI.tanggal_meninggal
          this.form.waktu_meninggal       = data.pelaporan_MATI.waktu_meninggal
          this.form.tempat_meninggal      = data.pelaporan_MATI.tempat_meninggal
          this.form.penyebab_meninggal    = data.pelaporan_MATI.penyebab_meninggal
          
          this.form.bukti_kematian        = data.pelaporan_MATI.bukti_kematian
          this.form.bukti_kematian_old    = data.pelaporan_MATI.bukti_kematian_old

          this.form.keterangan_deskel     = data.pelaporan_MATI.keterangan_deskel;
          this.form.keterangan_kecamatan  = data.pelaporan_MATI.keterangan_kecamatan;
          this.form.keterangan_kabupaten  = data.pelaporan_MATI.keterangan_kabupaten;
          this.form.status                = data.pelaporan_MATI.status;
          this.form.keterangan            = data.pelaporan_MATI.keterangan; 

          this.form.createdBy            = data.pelaporan_MATI.createdBy; 

          this.form.emailPemohon          = data.pelaporan_MATI.emailPemohon;
          this.form.email_fileOld         = data.pelaporan_MATI.email_file;
          this.form.email_from            = this.form.email_from;
          this.form.email_to              = this.form.emailPemohon;
          this.form.email_subject         = data.pelaporan_MATI.email_subject;
          if (data.pelaporan_MATI.email_html == undefined || data.pelaporan_MATI.email_html == null || data.pelaporan_MATI.email_html == '') {
            this.form.email_html          = ''
          } else {
            this.form.email_html          = data.pelaporan_MATI.email_html; 
          }


        this.wilayah = {
          uraian_provinsi : data.m_provinsi.uraian,
          kd_provinsi : data.m_provinsi.kd_provinsi,
          uraian_kabupaten : data.m_kabupaten.uraian,
          kd_kabupaten : data.m_kabupaten.kd_kabupaten,
          uraian_kecamatan : data.m_kecamatan.uraian,
          kd_kecamatan : data.m_kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
          kd_desa_kelurahan : data.m_desa_kelurahan.kd_desa_kelurahan,
        }; 
        this.wilayahMati = {
          uraian_provinsi       : data.wilayah_provinsi_mati.uraian,
          kd_provinsi           : data.wilayah_provinsi_mati.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_mati.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_mati.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_mati.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_mati.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_mati.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_mati.kd_desa_kelurahan,
        }; 
        
        // console.log(data.wilayah_provinsi_ibu.uraian);
        

      },
      
      editData : function(){


        this.$store.state.modal_loading = true;

        var formData = new FormData();

        formData.append("id", this.form.id);
        formData.append("m_provinsi",                 this.form.m_provinsi)
        formData.append("m_kabupaten",                this.form.m_kabupaten)
        formData.append("m_kecamatan",                this.form.m_kecamatan)
        formData.append("m_desa_kelurahan",           this.form.m_desa_kelurahan)
        formData.append("nama",                       this.form.nama)
        formData.append("nik",                        this.form.nik)
        formData.append("umur",                       this.form.umur)
        formData.append("pekerjaan",                  this.form.pekerjaan)
        formData.append("alamat",                     this.form.alamat)
        formData.append("hubungan_dengan_yang_mati",  this.form.hubungan_dengan_yang_mati)
        formData.append("nama_mati",                  this.form.nama_mati)
        formData.append("nik_mati",                   this.form.nik_mati)
        formData.append("jk_mati",                    this.form.jk_mati)
        formData.append("tgl_lahir_mati",             this.form.tgl_lahir_mati)
        formData.append("umur_mati",                  this.form.umur_mati)
        formData.append("agama_mati",                 this.form.agama_mati)
        formData.append("alamat_mati",                this.form.alamat_mati)
        formData.append("provinsi_mati",              this.form.provinsi_mati)
        formData.append("kabupaten_mati",             this.form.kabupaten_mati)
        formData.append("kecamatan_mati",             this.form.kecamatan_mati)
        formData.append("desa_kelurahan_mati",        this.form.desa_kelurahan_mati)
        formData.append("hari_meninggal",             this.form.hari_meninggal)
        formData.append("tanggal_meninggal",          this.form.tanggal_meninggal)
        formData.append("waktu_meninggal",            this.form.waktu_meninggal)
        formData.append("tempat_meninggal",           this.form.tempat_meninggal)
        formData.append("penyebab_meninggal",         this.form.penyebab_meninggal) 

        formData.append("bukti_kematian",             this.form.bukti_kematian)
        formData.append("bukti_kematian_old",         this.form.bukti_kematian_old)

        formData.append("status",                     this.form.status)
        formData.append("keterangan",                 this.form.keterangan)
        formData.append("keterangan_deskel",          this.form.keterangan_deskel)
        formData.append("keterangan_kecamatan",       this.form.keterangan_kecamatan)
        formData.append("keterangan_kabupaten",       this.form.keterangan_kabupaten)
        formData.append("status_deskel",              this.form.status_deskel)
        formData.append("status_kecamatan",           this.form.status_kecamatan)
        formData.append("status_kabupaten",           this.form.status_kabupaten)
        formData.append("createdAt_deskel",           this.form.createdAt_deskel)
        formData.append("createdAt_kecamatan",        this.form.createdAt_kecamatan)
        formData.append("createdAt_kabupaten",        this.form.createdAt_kabupaten) 


        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "editData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.$store.commit('notif_edit');
            this.getView();
        });
      },
      
      clearData(){
        this.form         = {};
        this.wilayah      = {};
        this.wilayahMati  = {};       

      },
      

    // ============================= KECAMATAN =============================
      getViewKecamatan : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "viewKecamatan", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                status_kecamatan : this.form.status_kecamatan,
                pl_provinsi       :this.$store.state.lcProfile.provinsi,
                pl_kabupaten      :this.$store.state.lcProfile.kabupaten,
                pl_kecamatan      :this.$store.state.lcProfile.kecamatan,
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data_kecamatan = res_data.data;
                this.page_last = res_data.jmlData; 
                // console.log("INI KECAMATAN")
                console.log(res_data);
        });
      },  
      editDataKecamatan : function(status){
        this.$store.state.modal_loading = true;

        // console.log(status)
        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "editDataKecamatan", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              keterangan_kecamatan : this.form.keterangan_kecamatan,
              createdAt_kecamatan : UMUM.NOW(),
              kategorix : status
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getViewKecamatan();
        });
      }, 
    // ============================= KECAMATAN =============================

    // ============================= KABUPATEN =============================
      getViewKabupaten : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "viewKabupaten", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                status_kabupaten : this.form.status_kabupaten
            })
          })
            .then(res => res.json())
            .then(res_data => {
              // console.log("TAAAAAAAAAAIIIIIIII")
                this.list_data_kabupaten = res_data.data;
                this.page_last = res_data.jmlData;
                // this.$store.commit("hideLoading");
                console.log(res_data);
        });
      },
      editDataKabupaten : function(status){
        this.$store.state.modal_loading = true;

        console.log("SA DI CLICK")
        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "editDataKabupaten", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              keterangan_kabupaten : this.form.keterangan_kabupaten,
              createdAt_kabupaten : UMUM.NOW(),
              kategorix : status
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getViewKabupaten();
        });
      },

      terbit_file_Kabupaten : function(){
        this.$store.state.modal_loading = true;

        console.log(this.form.email_fileOld);
        var formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("email_file", this.form.email_file); 
        formData.append("email_fileOld", this.form.email_fileOld); 
        formData.append("email_from", this.form.email_from)
        formData.append("email_to", this.form.email_to)
        formData.append("email_subject", this.form.email_subject) 
        formData.append("email_html", this.form.email_html)
        

        fetch(this.$store.state.url.URL_PELAPORAN_MATI + "file_terbitan_Kabupaten", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData,
        }).then(res_data => { 
            this.wa_notif()
            this.$store.state.modal_loading = false; 
            this.$store.commit('notif_terbit');
            this.getView();
        });
      },

      async wa_notif(){
          var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
            createdBy : this.form.createdBy,
            pesan     : 'Pelaporan Kematian'
          }))
          console.log(data);
      },      
    // ============================= KABUPATEN =============================

       bukaTab(linknya){
        window.open(linknya);
      },

    // ====================================== filter autocomplete ======================================
        renderChildProv(data) {
            return `
            <span><b>${data.kd_provinsi}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChildKab(data) {
            return `
            <span><b>${data.kd_kabupaten}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChildKec(data) {
            return `
            <span><b>${data.kd_kecamatan}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChild_des_kel(data) {
            return `
            <span><b>${data.kd_desa_kelurahan}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        get_auto(data){ 
          this.form.m_provinsi = data.m_provinsi  
        },

        get_auto_kab(data){ 
          this.form.m_kabupaten = data.m_kabupaten  
        },

        get_auto_kec(data){ 
          this.form.m_kecamatan = data.m_kecamatan  
        },

        get_auto_des_kel(data){ 
          this.form.m_desa_kelurahan = data.m_desa_kelurahan 
        },        
 
        prov_mati(data){  
          this.form.provinsi_mati = data.m_provinsi  
        }, 
        kab_mati(data){ 
          this.form.kabupaten_mati = data.m_kabupaten 
        }, 
        kec_mati(data){ 
          this.form.kecamatan_mati = data.m_kecamatan  
        }, 
        des_kel_mati(data){ 
          this.form.desa_kelurahan_mati = data.m_desa_kelurahan  
        },    
 
    // ====================================== filter autocomplete ======================================
      counterLabelFn ({ totalSize, filesNumber, maxFiles }) {
        return `${filesNumber} files of ${maxFiles} | ${totalSize}`
      },

      CariData(){
        
        if (this.$store.state.lcProfile.kelas == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas == 'kabupaten') {
          this.getViewKabupaten() 
        }else{
          this.getView();
        } 
      },
 
      cekButton_status_kecamatan: function(data){  
          var a = data.pelaporan_MATI.status 
          var status_kab = data.pelaporan_MATI.status_kabupaten  
          if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
            if (status_kab == 1) {
              return true
            }
            return false
          }else{
            if (a == 1) {
              return true
            }else{
              return false
            }
          }  
        },

      
    },
    mounted(){
      this.getView()
      this.CariData()
      this.$store.state.lcProfile.kelas
      this.$store.state.lcProfile.id
      var email_from          = this.$store.state.lcProfile.email 
      var email_pemohon       = this.$store.state.lcProfile.email 
      this.form.emailPemohon  = email_pemohon
      this.form.email_from    = email_from 
    }
}
